export const server = "https://v2-survey-api.withchildren.org";
// export const server = "https://unicef-survey-dev-api.batoners.org";
export const files = process.env.PUBLIC_URL;
